import React from "react";
import {
  Box,
  TableCell,
  TableHead,
  TableRow,
  TableSortLabel,
} from "@mui/material";
import { EnhancedTablePropsClips } from "./ClipsUtilities/clipsInterfaces";
import { visuallyHidden } from "@mui/utils";
import { AlertData, HeadCell } from "../Alerts/AlertsUtils/alertsInterfaces";

const headCells: readonly HeadCell[] = [
  {
    id: "customer_name",
    numeric: false,
    label: "Site",
  },
  {
    id: "camera_name",
    numeric: false,
    label: "Camera Name",
  },
  {
    id: "clip_received_local",
    numeric: false,
    label: "Received",
  },
  {
    id: "clip_result",
    numeric: false,
    label: "Clip Result",
  },
  {
    id: "probability",
    numeric: true,
    label: "Probability",
  },
  {
    id: "file_id",
    numeric: false,
    label: "File ID",
  },
];

export const EnhancedFrontelTableHead = (props: EnhancedTablePropsClips) => {
  const { onRequestSort, orderBy, order } = props;
  const createSortHandler =
    (property: keyof AlertData) => (event: React.MouseEvent<unknown>) => {
      onRequestSort(event, property);
    };
  return (
    <TableHead>
      <TableRow>
        {headCells.map((headCell) => (
          <TableCell
            key={headCell.id}
            align="left"
            sortDirection={orderBy === headCell.id ? order : false}
            sx={{
              fontFamily: "mulish",
              fontWeight: 700,
              fontSize: 10,
              whiteSpace: "nowrap",
            }}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : "asc"}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <Box component="span" sx={visuallyHidden}>
                  {order === "desc" ? "sorted descending" : "sorted ascending"}
                </Box>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
};
